import { Grid, Stack } from '@mui/material';
import React, { FC } from 'react';
import { DuplicatesWarning } from '../../../support/components';
import {
    InfoActiveSupportPeriods,
    InfoSupportees,
    RegistrationFoodRestrictions,
    RegistrationForm,
    RegistrationWarningPanel,
} from '../../components';
import { ISupportCaseInfo } from '../../models';
import { RegistrationLastRegistrations } from '../registration-last-registrations/registration-last-registrations.component';
import { useBreakpoint } from '../../../shared';

interface Props {
    supportCase: ISupportCaseInfo;
}

export const Registration: FC<Props> = ({ supportCase }) => {
    const { showWarningPanel } = window.carity.environment;
    const lg = useBreakpoint('lg');
    const md = useBreakpoint('md');
    const hasFoodRestrictions = (supportCase.foodRestrictions || []).length > 0;

    return (
        <Stack spacing={2}>
            <DuplicatesWarning supportCaseId={supportCase.supportCaseId} />
            <Grid container justifyContent="center" spacing={2} direction={md ? 'row' : 'column-reverse'}>
                <Grid size={{ sm: 12, md: 6, lg: 8 }}>
                    <Grid container spacing={2}>
                        <Grid size={hasFoodRestrictions ? { xs: 12, sm: 6, md: 12, lg: 6 } : { xs: 12 }}>
                            <InfoSupportees supportCase={supportCase} hasFoodRestrictions={hasFoodRestrictions} />
                        </Grid>

                        <Grid
                            size={hasFoodRestrictions ? { xs: 12, sm: 6, md: 12, lg: 6 } : { xs: 12 }}
                            sx={{ display: hasFoodRestrictions ? 'block' : 'none' }}
                        >
                            <RegistrationFoodRestrictions
                                supportCase={supportCase}
                                hasFoodRestrictions={hasFoodRestrictions}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                            {showWarningPanel ? (
                                <RegistrationWarningPanel supportCase={supportCase} />
                            ) : (
                                <InfoActiveSupportPeriods supportPeriods={supportCase.activeSupportPeriods} />
                            )}
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                            {(lg || !md) && (
                                <RegistrationLastRegistrations lastRegistrations={supportCase.lastRegistrations} />
                            )}
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ sm: 12, md: 6, lg: 4 }}>
                    <Stack spacing={2}>
                        <RegistrationForm supportCase={supportCase} />
                        {!lg && md && (
                            <RegistrationLastRegistrations lastRegistrations={supportCase.lastRegistrations} />
                        )}
                    </Stack>
                </Grid>
            </Grid>
        </Stack>
    );
};
